var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "UploadFile-container" },
    [
      _vm.fileList.length
        ? [
            _c(
              "transition-group",
              {
                staticClass: "el-upload-list el-upload-list--picture-card",
                attrs: { tag: "ul", name: "el-list" },
              },
              _vm._l(_vm.fileList, function (file, index) {
                return _c(
                  "li",
                  {
                    key: file.fileId,
                    staticClass: "el-upload-list__item is-success",
                  },
                  [
                    _c("el-image", {
                      ref: "image" + index,
                      refInFor: true,
                      staticClass: "el-upload-list__item-thumbnail",
                      attrs: {
                        src: _vm.define.comUrl + file.url,
                        "preview-src-list": _vm.getImgList(_vm.fileList),
                        "z-index": 10000,
                      },
                    }),
                    _c(
                      "span",
                      { staticClass: "el-upload-list__item-actions" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "el-upload-list__item-preview",
                            on: {
                              click: function ($event) {
                                return _vm.handlePictureCardPreview(index)
                              },
                            },
                          },
                          [_c("i", { staticClass: "el-icon-zoom-in" })]
                        ),
                        !_vm.disabled
                          ? _c(
                              "span",
                              {
                                staticClass: "el-upload-list__item-delete",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRemove(index)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "el-icon-delete" })]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ]
        : _vm._e(),
      _c("el-upload", {
        ref: "elUpload",
        staticClass: "upload-btn",
        attrs: {
          action: _vm.define.comUploadUrl + "/" + _vm.type,
          headers: _vm.uploadHeaders,
          "on-success": _vm.handleSuccess,
          multiple: _vm.limit !== 1,
          "show-file-list": false,
          accept: "image/*",
          "before-upload": _vm.beforeUpload,
          "on-exceed": _vm.handleExceed,
          disabled: _vm.disabled,
          "list-type": "picture-card",
          limit: _vm.limit,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }